// Deterministic spintax expander: expands patterns like "{a|b|c}" using a seeded RNG
// Usage: expandSpintax("{quick|fast} intro", seedString)

function xorshift32(seed: number) {
  let x = seed || 1;
  return function rand() {
    x ^= x << 13; x ^= x >>> 17; x ^= x << 5;
    // Convert to [0,1)
    return ((x >>> 0) / 0xFFFFFFFF);
  };
}

export function seedFromString(s: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h || 1;
}

export function expandSpintax(input: string, seedKey: string): string {
  const rand = xorshift32(seedFromString(seedKey));
  const pattern = /\{([^{}]+)\}/g;
  let result = input;
  let safety = 0;
  while (pattern.test(result) && safety++ < 1000) {
    result = result.replace(pattern, (_, group) => {
      const options = group.split('|');
      const idx = Math.floor(rand() * options.length);
      return options[Math.max(0, Math.min(idx, options.length - 1))];
    });
  }
  return result;
}
